import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useDeleteUser = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const deleteUser = async (id: string) => {
        try {
            await axios.delete(`/api/user/${id}`);
        } catch (error) {
            throw new Error(t("messages.error.deleteUser"));
        }
    }

    return useMutation({
        mutationFn: deleteUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
            message.success(t("messages.success.deleteUser"));
        },
    });

}